/* eslint-disable max-len */
import * as Constants from '../constants';

const initialState = {
  loading: false,
  data: {},
  error: {},
  diagnosticsPromocode: {},
  selectedLab: {},
  testDetails: [],
  availableLabs: [],
  unAvailableLabs: {},
  selectedLPVariant: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.GET_DIAGNOSTICS_CART_START:
      return Object.assign({}, { ...state, loading: true });
    case Constants.GET_DIAGNOSTICS_CART_SUCCESS:
      return Object.assign({ ...state }, { loading: false, data: action.data.data, testDetails: action.data.data.test_details, selectedLab: action.data.data.lab_details, error: {} });
    case Constants.GET_DIAGNOSTICS_CART_FAILURE:
      return Object.assign({ ...state }, { loading: false, data: {}, error: action.data.error, testDetails: [], selectedLab: {} });
    case Constants.ADD_TO_CART_DIAG_START:
      return Object.assign({ ...state }, { loading: true });
    case Constants.ADD_TO_CART_DIAG_SUCCESS:
      return Object.assign({ ...state }, { loading: false });
    case Constants.ADD_TO_CART_DIAG_FAILURE:
      return Object.assign({ ...state }, { loading: false });
    case Constants.SET_SELECTED_LAB:
      return Object.assign({ ...state }, { loading: false, selectedLab: action.data });
    case Constants.GET_AVAILABLE_LAB_START:
      return Object.assign({ ...state }, { loading: true });
    case Constants.GET_AVAILABLE_LAB_SUCCESS:
      return Object.assign({ ...state }, { loading: false, availableLabs: action.data.data.available_at, unAvailableLabs: {} });
    case Constants.GET_AVAILABLE_LAB_FAILURE:
      return Object.assign({ ...state }, { loading: false, error: action.data.error });
    case Constants.GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_START:
      return Object.assign({ ...state }, { loading: true });
    case Constants.GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_SUCCESS:
      return Object.assign({ ...state }, { loading: false, availableLabs: action.data.data.labs_available, unAvailableLabs: action.data.data.labs_unavailable });
    case Constants.GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_FAILURE:
      return Object.assign({ ...state }, { loading: false, error: action.data.error });
    case Constants.DELETE_DIAGNOSTICS_ITEM_START:
      return Object.assign({ ...state }, { loading: true });
    case Constants.DELETE_DIAGNOSTICS_ITEM_SUCCESS:
      return Object.assign({ ...state }, { loading: false });
    case Constants.DELETE_DIAGNOSTICS_ITEM_FAILURE:
      return Object.assign({ ...state }, { loading: false, error: action.data.error });
    case Constants.CHANGE_DIAGNOSTICS_LAB_START:
      return Object.assign({ ...state }, { loading: true });
    case Constants.CHANGE_DIAGNOSTICS_LAB_SUCCESS:
      return Object.assign({ ...state }, { loading: false });
    case Constants.CHANGE_DIAGNOSTICS_LAB_FAILURE:
      return Object.assign({ ...state }, { loading: false, error: action.data.error });
    case Constants.SET_DIAGNOSTICS_PROMOCODE_START:
      return { ...state, loading: true, action };
    case Constants.SET_DIAGNOSTICS_PROMOCODE_SUCCESS:
    case Constants.SET_DIAGNOSTICS_PROMOCODE_FAILURE:
      return Object.assign({}, { ...state }, { diagnosticsPromocode: { ...action.data }, loading: false, action });
    case Constants.RESET_DIAGNOSTICS_PROMOCODE:
      return Object.assign({}, { ...state }, { diagnosticsPromocode: {}, loading: false, action });
    case Constants.SET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT:
      return Object.assign({}, { ...state }, { selectedLPVariant: { ...action.data } });
    case Constants.RESET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT:
      return Object.assign({}, { ...state }, { selectedLPVariant: {} });
    default:
      return { ...state };
  }
}
